import { useEffect, useState } from 'react';
import { requestService } from 'shared/utils/services/requestService';

export const useConstructorUserParams = () => {
  const [constructorUserParams, setConstructorUserParams] = useState(null);

  useEffect(() => {
    const fetchConstructorUserParams = async () => {
      try {
        const response = await requestService({ url: '/web-api/v1/constructor_user_params' });
        if (response) {
          setConstructorUserParams(response);
        }
      } catch {
        // do nothing
      }
    };

    void fetchConstructorUserParams();
  }, []);

  return constructorUserParams;
};
